import { render, staticRenderFns } from "./OrderCreatorServiceGlobalPackage.vue?vue&type=template&id=36d29e1c&scoped=true&"
import script from "./OrderCreatorServiceGlobalPackage.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceGlobalPackage.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServiceGlobalPackage.vue?vue&type=style&index=0&id=36d29e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d29e1c",
  null
  
)

export default component.exports